<template>
  <div class="ma-6">
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="heading primary white--text">{{dialogtitle}}</v-card-title>
        <v-card-text class="mt-4">
          <v-text-field readonly label="NoInvoice" v-model="itemtoapprove.invoice"></v-text-field>
          <v-text-field readonly label="Nominal" v-model="itemtoapprove.nominal"></v-text-field>
          <v-text-field autofocus label="Masukkan Noref atau keterangan" v-model="deskripsiapprove"></v-text-field>
        </v-card-text>
        <v-divider/>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="red darken-1" dark @click.native="setdialog(false)">Batal</v-btn>
          <v-btn elevation="0" color="primary darken-1"  @click.native="approvetiket">Approve</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="page-header-left">
      <h2 class="pr-3">Topup Saldo</h2>
      <div class="listtotal pt-2">
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">account_balance_wallet</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Jumlah</div>
            <div>{{formatAngka(sumcashin.jml)}}</div>
          </div>
        </v-card>
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">account_balance_wallet</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Amount</div>
            <div>{{formatAngka(sumcashin.amount)}}</div>
          </div>
        </v-card>
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="accent" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">account_balance_wallet</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Pending</div>
            <div>{{formatAngka(sumcashin.pending)}}</div>
          </div>
        </v-card>
      </div>
    </div>
  <div class="mt-4 pr-0 pl-0 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)">
    <v-toolbar elevation="0">
      <v-text-field
          flat
          solo
          clearable
          prepend-icon="search"
          placeholder="Type something"
          v-model="opsitabletrx.search"
          hide-details
          class=""
      ></v-text-field>
      <v-spacer></v-spacer>
      <div class="mt-6">
        <v-select
            clearable
            label="Status Transaksi"
            item-text="label"
            item-value="id"
            v-model="opsitabletrx.statustrx"
            :items="statuses"
        ></v-select>
      </div>
      <div class="mt-6">
        <v-autocomplete
            clearable
            v-model="opsitabletrx.methode"
            :items="account"
            label="Payment Method"
            item-text="name"
            item-value="name"
            dense/>
      </div>
      <div class="mt-6">
        <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="opsitabletrx.awal"
                label="Tanggal Awal"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitabletrx.awal" @input="menu1 = false"></v-date-picker>
        </v-menu>
      </div>
      <div class="mt-6">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="opsitabletrx.akhir"
                label="Tanggal Akhir"
                prepend-icon="event"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="opsitabletrx.akhir" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </div>
      <v-btn small elevation="0" class="ml-2" color="primary" @click.native="getdata">
        <v-icon dark>refresh</v-icon>Refresh
      </v-btn>
      <vue-blob-json-csv
          file-type="csv"
          file-name="cashin"
          :data="cashin_download">
        <v-btn small text class="primary ml-2"><v-icon class="mr-2">fa-file-excel-o</v-icon> Download</v-btn>
      </vue-blob-json-csv>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
        :headers="headers"
        :search="search"
        :items="cashin"
        class="elevation-0"
        item-key="id"
        :options.sync="opsitabletrx"
        :server-items-length="totalcashin"
        :loading="loading"
        @update:options="getdata">

      <template v-slot:item.nominal="{ item }">
        <div  class="text-right">
          {{formatAngka(item.nominal)}}
        </div>
      </template>
      <template v-slot:item.paymenthistorydatetime="{ item }">
        {{formatDate(item.paymenthistorydatetime)}}
      </template>
      <template v-slot:item.member.membername="{ item }">
        {{toupper(item.member.membername)}}
      </template>
      <template v-slot:item.status="{ item }">
        <div class="ma-4 text-xs-left">
          <v-chip
              :color="colorStatus(item.status)"
              small
              text-color="white">
            {{ statusText(item.status) }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.aksi="{ item }">
        <v-btn v-if="item.status==='1'" small dark text @click.native="openApprove(item)" class="primary ml-2">
          <v-icon small dark class="mr-1">check</v-icon>
          Approve
        </v-btn>
        <v-btn v-if="item.status==='1'"  small dark text @click.native="rejecttiket(item)" class="red ml-2">
          <v-icon small dark class="mr-1">delete</v-icon>
          Reject
        </v-btn>
        <v-btn v-if="item.status==='2'"  small dark text @click.native="cancelTicket(item)" class="red ml-2">
          <v-icon small dark class="mr-1">delete</v-icon>
          Cancel
        </v-btn>
      </template>
    </v-data-table>
  </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import Utils from '@/plugins/utils'

export default {
  name: 'Casin',
  data: () => ({
    search: '',
    tab: '',
    dialogtitle: 'Konfirmasi Deposit',
    deskripsiapprove: '',
    itemtoapprove: {},
    menu1: false,
    menu2: false,
    dateawal: moment().add(7, 'hours').toISOString().substr(0, 10),
    dateakhir: moment().add(7, 'hours').toISOString().substr(0, 10),
    opsitabletrx: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      statustrx: '',
      sortBy: ['id'],
      awal: moment().add(7, 'hours').toISOString().substr(0, 10),
      akhir: moment().add(7, 'hours').toISOString().substr(0, 10)
    },
    statuses: [
      {
        id: 1,
        label: 'Pending'
      },
      {
        id: 2,
        label: 'Approve'
      },
      {
        id: 3,
        label: 'Reject'
      },
      {
        id: 4,
        label: 'Cancel'
      }
    ],
    headers: [
      {
        text: 'TrxId',
        value: 'id'
      },
      {
        text: 'Waktu',
        value: 'paymenthistorydatetime'
      },
      {
        text: 'Member',
        value: 'member.membername'
      },
      {
        text: 'Method',
        value: 'method'
      },
      {
        text: 'Nominal',
        value: 'nominal'
      },
      {
        text: 'Status',
        value: 'status'
      },
      {
        text: 'Remark',
        value: 'approveddescription'
      },
      {
        text: 'Aksi',
        value: 'aksi'
      }
    ]
  }),
  mounted () {
    this.getAccount()
    this.getSumcashin(this.opsitabletrx)
  },
  computed: {
    ...mapState('AdmStore', ['loading', 'dialog', 'overlay', 'cashin', 'totalcashin', 'cashin_download', 'account', 'sumcashin'])
  },
  methods: {
    ...mapActions('AdmStore', ['getCashIn', 'setdialog', 'rejectCashin', 'approveCashIN', 'getCashInDownload', 'getAccount', 'getSumcashin']),
    formatAngka (val) {
      if (val) {
        return Utils.formatAngka(val)
      } else {
        return 0
      }
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    settitledialog (val) {
      this.dialogtitle = 'Konfirmasi Deposit ' + val.member.membername
    },
    colorStatus (val) {
      if (val === '0') {
        return 'blue'
      }
      if (val === '1') {
        return 'blue'
      }
      if (val === '2') {
        return 'green'
      }
      if (val === '3') {
        return 'red'
      }
      if (val === '4') {
        return 'red'
      }
    },
    getdata () {
      this.getSumcashin(this.opsitabletrx)
      this.getCashIn(this.opsitabletrx)
      this.getCashInDownload(this.opsitabletrx)
    },
    toupper (val) {
      return val.toUpperCase()
    },
    statusText (val) {
      if (val === '0') {
        return 'Pending'
      }
      if (val === '1') {
        return 'Pending'
      }
      if (val === '2') {
        return 'Approve'
      }
      if (val === '3') {
        return 'Reject'
      }
      if (val === '4') {
        return 'Cancel'
      }
    },
    openApprove (item) {
      this.itemtoapprove = item
      this.dialogtitle = 'Konfirmasi Deposit ' + item.member.membername
      this.setdialog(true)
    },
    approvetiket () {
      var a = {
        id: this.itemtoapprove.id,
        description: this.deskripsiapprove
      }
      this.approveCashIN(a)
      this.itemtoapprove = {}
      this.setdialog(false)
    },
    rejecttiket (item) {
      this.$confirm('Yakin akan Reject ' + item.member.membername + ' ' + this.formatAngka(item.nominal), { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          const a = {
            id: item.id,
            status: '3'
          }
          console.log(a)
          this.rejectCashin(a)
        }
      })
    },
    cancelTicket (item) {
      this.$confirm('Yakin akan Cancel ' + item.member.membername + ' ' + this.formatAngka(item.nominal), { color: 'red', title: 'Konfirmasi', icon: 'fa-question' }).then(res => {
        if (res) {
          const a = {
            id: item.id,
            status: '4'
          }
          console.log(a)
          this.rejectCashin(a)
        }
      })
    }
  }
}
</script>

<style scoped>
.listtotal {
  display:flex;
  flex-wrap: wrap;
}
.icondash {
  margin-left: 6px;
  margin-top: 5px;
}
</style>
